import { ThemedText } from "@/components/ThemedText";
import { DisplayName } from "@/components/ui/DisplayName";
import VerifiedBadge from "@/components/ui/VerifiedBadge";
import React from "react";

type Props = {
  displayName?: string | null;
  username?: string | null;
  isVerified?: boolean;
};

const truncateStyle = {
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  flexShrink: 1,
  minWidth: 0,
} as any;

const badgeStyle = { marginLeft: 4, flexShrink: 0 } as any;

export function AuthorName({ displayName, username, isVerified }: Props) {
  const trimmedDisplay = displayName?.trim();
  const trimmedUsername = username?.trim();

  if (!trimmedDisplay && !trimmedUsername) {
    return (
      <>
        <DisplayName
          user={null}
          type="defaultSemiBold"
          style={truncateStyle}
        />
        {isVerified ? <VerifiedBadge size={14} style={badgeStyle} /> : null}
      </>
    );
  }

  return (
    <>
      {trimmedDisplay ? (
        <ThemedText type="defaultSemiBold" style={truncateStyle}>
          {trimmedDisplay}
        </ThemedText>
      ) : null}
      {isVerified ? <VerifiedBadge size={14} style={badgeStyle} /> : null}
      {trimmedUsername ? (
        <ThemedText
          style={{ ...truncateStyle, color: "#666", marginLeft: 4 }}
        >
          @{trimmedUsername}
        </ThemedText>
      ) : null}
    </>
  );
}
